 <template>
  <section class="gx-bm">
    <template v-if="page === 'main'">
      <nav class="gx-bm__tabs">
        <button :class="{ on: tab === 'modify' }" @click="tab = 'modify'">修改内容</button>
        <button :class="{ on: tab === 'records' }" @click="tab = 'records'">批量修改记录</button>
      </nav>
      <main v-if="tab === 'modify'" class="gx-bm__main">
        <div class="gx-bm__heading">
          <h1>批量修改</h1>
          <span>帮助教程</span>
        </div>
        <section v-for="group in groups" :key="group.title" class="gx-bm__group">
          <header>
            <i></i>
            <strong>{{ group.title }}</strong>
            <small>（{{ group.items.length }} 项）</small>
          </header>
          <div class="gx-bm__grid">
            <button v-for="item in group.items" :key="item.id" class="gx-bm__card" @click="openCard(item)">
              <em v-if="item.badge" :class="item.badge">{{ item.badge === 'hot' ? '官方HOT' : '单品直降' }}</em>
              <b>{{ item.icon }}</b>
              <strong>{{ item.label }}</strong>
              <small v-if="item.sub">{{ item.sub }}</small>
            </button>
          </div>
        </section>
      </main>
      <main v-else-if="tab === 'records-old'" class="gx-bm__main gx-bm__records">
        <div class="gx-bm__tags">
          <button
            v-for="item in recordTags"
            :key="item"
            :class="{ on: recordType === item }"
            @click="recordType = item">
            {{ item }}
          </button>
        </div>
        <div class="gx-bm__table-wrap">
          <table>
            <thead>
              <tr>
                <th>修改内容</th>
                <th>处理进度</th>
                <th>状态</th>
                <th>成功数</th>
                <th>失败数</th>
                <th>总数</th>
                <th>时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in visibleRecords" :key="item.id">
                <td>
                  <strong>{{ item.type }}</strong>
                  <small>{{ item.rule }}</small>
                </td>
                <td>
                  <div class="gx-bm__progress"><i :style="{ width: item.progress + '%' }"></i></div>
                  <b>{{ item.progress }}%</b>
                </td>
                <td>
                  <span class="gx-bm__status" :class="item.status">{{ item.status }}</span>
                </td>
                <td class="success">{{ item.success }}</td>
                <td class="danger">{{ item.fail }}</td>
                <td>{{ item.total }}</td>
                <td>
                  <small>
                    修改 {{ item.time }}
                    <br />
                    恢复 {{ item.restore || '—' }}
                  </small>
                </td>
                <td><button class="gx-bm__mini primary" @click="detail = item">查看详情</button></td>
              </tr>
            </tbody>
          </table>
          <footer>
            共 {{ visibleRecords.length }} 条 · 10条/页
            <span>
              ‹　
              <b>1</b>
              　2　›　前往　
              <input value="1" />
              页
            </span>
          </footer>
        </div>
      </main>
      <batch-modify-records v-else />
    </template>
    <template v-else-if="page === 'title-new'"><batch-modify-title @back="page = 'main'" /></template>
    <template v-else-if="page === 'short-title-new'"><batch-modify-short-title @back="page = 'main'" /></template>
    <template v-else-if="page === 'price-new'"><batch-modify-price @back="page = 'main'" /></template>
    <template v-else-if="page === 'stock-new'"><batch-modify-stock @back="page = 'main'" /></template>
    <template v-else-if="page === 'size-weight-new'"><batch-modify-size-weight @back="page = 'main'" /></template>
    <template v-else-if="page === 'delete-new'"><batch-modify-delete @back="page = 'main'" /></template>
    <template v-else-if="page === 'detail-img-new'"><batch-modify-detail @back="page = 'main'" /></template>
    <template v-else-if="page === 'main-img-new'"><batch-modify-main-image @back="page = 'main'" /></template>
    <template v-else-if="page === 'huohao-new'"><batch-modify-huohao @back="page = 'main'" /></template>
    <template v-else-if="page === 'sku-spec-new'"><batch-modify-sku-spec @back="page = 'main'" /></template>
    <template v-else-if="page === 'import-spu'"><batch-modify-import type="spu" @back="page = 'main'" /></template>
    <template v-else-if="page === 'import-sku'"><batch-modify-import type="sku" @back="page = 'main'" /></template>
    <template v-else-if="page === 'title'">
      <header class="gx-bm__title-head">
        <div>
          <button @click="page = 'main'">‹ 返回</button>
          <span>
            云库工作台　›　批量修改　›　
            <strong>标题</strong>
          </span>
        </div>
        <a>帮助教程</a>
        <h1>批量修改标题</h1>
        <nav class="gx-bm__tabs">
          <button :class="{ on: titleTab === 'range' }" @click="titleTab = 'range'">按范围修改</button>
          <button :class="{ on: titleTab === 'goods' }" @click="titleTab = 'goods'">按商品修改</button>
        </nav>
      </header>
      <main class="gx-bm__title-main">
        <div v-if="titleTab === 'range'" class="gx-bm__filters">
          <div v-for="field in filters" :key="field">
            <label>{{ field }}</label>
            <input :placeholder="field.includes('范围') ? '最小　~　最大' : '请输入'" />
          </div>
          <footer>
            <button>查询</button>
            <button class="plain">重置</button>
          </footer>
        </div>
        <div v-else class="gx-bm__choose">
          <button @click="selector = true">选择商品</button>
          <span v-if="selected.length">已选 {{ selected.length }} 件商品</span>
        </div>
        <div class="gx-bm__fail">
          <strong>标题超长容错：</strong>
          <label>
            <input v-model="failMode" type="radio" value="fail" />
            按失败处理
          </label>
          <label>
            <input v-model="failMode" type="radio" value="truncate" />
            自动删除标题后面的相应字数
          </label>
        </div>
        <section class="gx-bm__methods">
          <header>
            <i></i>
            修改内容
          </header>
          <article v-for="method in methods" :key="method.id">
            <label>
              <input v-model="method.on" type="checkbox" />
              方式{{ method.id }}：{{ method.name }}
            </label>
            <div v-if="method.on" class="gx-bm__method-body">
              <template v-if="method.id === 3">
                <input placeholder="请输入新标题内容（最多60字）" maxlength="60" />
              </template>
              <template v-else-if="method.id === 4">
                <textarea placeholder="多个关键词用逗号分隔，最多10000字"></textarea>
                <select>
                  <option>保留第一个</option>
                  <option>全部替换</option>
                </select>
              </template>
              <template v-else-if="method.id === 5">
                <label v-for="option in filterOptions" :key="option">
                  <input type="checkbox" />
                  {{ option }}
                </label>
              </template>
              <template v-else-if="method.id === 6">
                <label>
                  <input type="radio" checked />
                  标题英文部分转小写
                </label>
                <label>
                  <input type="radio" />
                  标题英文部分转大写
                </label>
              </template>
              <template v-else-if="method.id === 7">
                <input placeholder="查找内容" />
                <span>→</span>
                <input placeholder="替换为" />
                <button class="gx-bm__mini">+ 添加</button>
              </template>
              <template v-else-if="method.id === 8">
                <span>前缀</span>
                <input placeholder="前缀内容" />
                <span>后缀</span>
                <input placeholder="后缀内容" />
              </template>
              <template v-else-if="method.id === 9">
                <span>删除首部字数</span>
                <select>
                  <option>0（不删除）</option>
                  <option>1</option>
                </select>
                <span>删除尾部字数</span>
                <select>
                  <option>0（不删除）</option>
                  <option>1</option>
                </select>
              </template>
              <template v-else>
                <input
                  :placeholder="
                    method.id === 1 ? '输入热搜词，多个词用逗号分隔' : method.id === 2 ? 'AI智能生成标题' : '替换前内容'
                  " />
              </template>
            </div>
          </article>
        </section>
        <div class="gx-bm__options">
          <label>
            <input type="checkbox" />
            针对尺码表必填，若尺码表非法，AI智能生成尺码表
          </label>
          <span>同步调整上下架</span>
          <select>
            <option>不调整上下架</option>
            <option>上架</option>
            <option>下架</option>
          </select>
        </div>
        <section v-if="preview" class="gx-bm__preview">
          <header>
            共找到
            <b>23</b>
            个商品
            <button @click="preview = false">收起预览</button>
          </header>
          <table>
            <thead>
              <tr>
                <th>商品信息</th>
                <th>调整后内容</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="index in 5" :key="index">
                <td>1000{{ index }}　商品标题示例 {{ index }} — 夏季宽松T恤</td>
                <td>
                  <textarea>夏季新款 商品标题示例 {{ index }} — 夏季宽松T恤</textarea>
                </td>
                <td><button class="gx-bm__mini primary">保存修改</button></td>
              </tr>
            </tbody>
          </table>
        </section>
      </main>
      <footer class="gx-bm__bottom">
        <button @click="preview = !preview">修改内容预览</button>
        <button class="green" @click="notice = true">开始批量修改</button>
        <label>
          <input type="checkbox" />
          定时执行
        </label>
      </footer>
    </template>
    <template v-else>
      <main class="gx-bm__placeholder">
        <b>{{ activeCard.icon }}</b>
        <strong>{{ activeCard.label }}</strong>
        <span>此功能子页面正在建设中，敬请期待</span>
        <button @click="page = 'main'">返回批量修改</button>
      </main>
    </template>
    <div v-if="notice" class="gx-bm__mask">
      <div class="gx-bm__modal">
        <header>
          <strong>提示</strong>
          <button @click="notice = false">×</button>
        </header>
        <main>
          <b>!</b>
          <p>功能开发中，敬请期待</p>
        </main>
        <footer><button @click="notice = false">我知道了</button></footer>
      </div>
    </div>
    <div v-if="selector" class="gx-bm__mask">
      <div class="gx-bm__selector">
        <header>
          <strong>选择修改商品</strong>
          <button @click="selector = false">×</button>
        </header>
        <main>
          <button
            v-for="good in goods"
            :key="good.id"
            :class="{ selected: selected.includes(good.id) }"
            @click="toggleGood(good.id)">
            <b>📦</b>
            <strong>{{ good.title }}</strong>
            <small>{{ good.price }}</small>
          </button>
        </main>
        <footer>
          已选 {{ selected.length }} 件
          <button @click="selector = false">确定</button>
        </footer>
      </div>
    </div>
    <div v-if="detail" class="gx-bm__mask">
      <div class="gx-bm__detail">
        <header>
          <strong>查看详情</strong>
          <button @click="detail = null">×</button>
        </header>
        <nav>成功商品（{{ detail.success }}）　　失败商品（{{ detail.fail }}）</nav>
        <table>
          <thead>
            <tr>
              <th>商品主图</th>
              <th>商品ID</th>
              <th>商品标题</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index in 3" :key="index">
              <td>📦</td>
              <td>100{{ index }}0</td>
              <td>商品示例标题 {{ index }} — 宽松百搭春夏新款</td>
            </tr>
          </tbody>
        </table>
        <footer><button @click="detail = null">关闭</button></footer>
      </div>
    </div>
  </section>
</template>

<script>
import BatchModifyRecords from './BatchModifyRecords.vue'
import BatchModifyTitle from './BatchModifyTitle.vue'
import BatchModifyShortTitle from './BatchModifyShortTitle.vue'
import BatchModifyPrice from './BatchModifyPrice.vue'
import BatchModifyStock from './BatchModifyStock.vue'
import BatchModifySizeWeight from './BatchModifySizeWeight.vue'
import BatchModifyDelete from './BatchModifyDelete.vue'
import BatchModifyDetail from './BatchModifyDetail.vue'
import BatchModifyMainImage from './BatchModifyMainImage.vue'
import BatchModifyHuohao from './BatchModifyHuohao.vue'
import BatchModifySkuSpec from './BatchModifySkuSpec.vue'
import BatchModifyImport from './BatchModifyImport.vue'

const groupData = [
  // ['修改基础信息', [['title', '标题', '✏'], ['short-title', '导购短标题', '✦'], ['brand', '品牌', '◈'], ['attrs', '商品属性', '☰'], ['cross-attrs', '跨类目属性', '⇌'], ['fabric', '面料材质', '◫', '水洗标/吊牌图'], ['sku-no', '货号', '⊞'], ['del-goods', '删除商品', '⊗'], ['low-eff', '下架/删除低效品', '↓', '', 'hot'], ['on-off', '上下架', '⇅'], ['timed', '定时上下架', '◷'], ['channel', '创建渠道品', '⊕'], ['flash', '限时限量购', '⚡', '', 'sale'], ['food-safe', '食品安全/营养成分表', '◉']]],
  [
    '修改基础信息',
    [
      ['title', '标题', '✏'],
      ['short-title', '导购短标题', '✦'],
      // ['brand', '品牌', '◈'],
      // ['attrs', '商品属性', '☰'],
      // ['cross-attrs', '跨类目属性', '⇌'],
      // ['fabric', '面料材质', '◫', '水洗标/吊牌图'],
      ['sku-no', '货号', '⊞'],
      ['size-weight', '尺寸与重量', '⊡'],
      ['del-goods', '删除商品', '⊗'],
      // ['low-eff', '下架/删除低效品', '↓', '', 'hot'],
      // ['on-off', '上下架', '⇅'],
      // ['timed', '定时上下架', '◷'],
      // ['channel', '创建渠道品', '⊕'],
      // ['flash', '限时限量购', '⚡', '', 'sale'],
      // ['food-safe', '食品安全/营养成分表', '◉']
    ]
  ],
  [
    '修改图文价格库存',
    [
      ['price', '价格(SKU)', '¥'],
      ['stock', '库存', '▤'],
      // ['sku-code', 'SKU编码', '▣'],
      ['sku-spec', 'SKU规格名称/备注', '≋'],
      // ['add-sku', '添加SKU', '⊞', '添加SKU升级款'],
      // ['del-sku', '删除SKU', '⊟', '支持副低价款'],
      // ['ship-mode', '发货模式(SKU时效)', '🚚'],
      // ['presell', '预售时间', '📅'],
      ['detail-img', '商品详情图', '🖼'],
      ['main-img', '主图', '🎨'],
      // ['main-34', '主图3:4', '⬛'],
      // ['stock-cnt', '库存计件', '🔢'],
      // ['size-tbl', '尺码表', '📐'],
      // ['area-stock', '区域库存开关', '🌍'],
      // ['sku-status', 'SKU状态', '●'],
      // ['sku-spec-img', 'SKU规格图', '🖼'],
      // ['sku-img', 'SKU图', '📷'],
      // ['replace-img', '替换商品图片', '🔄'],
      // ['unified-sku', '统一设置SKU', '⚙'],
      // ['white-bg', '白底图', '⬜'],
      // ['import-multi', '导入修改(多字段)', '📤'],
      // ['sku-barcode', 'SKU条形码（国补码）', '▦'],
      // ['sku-tpl', '引用SKU模板', '📋'],
      // ['multi-addr', '多地址退货策略', '↩'],
      // ['union-str', '精选联盟策略', '🤝'],
      // ['main-video', '主图视频', '▶']
    ]
  ],
  [
    '修改商品信息',
    [
      ['import-spu', '导入修改商品信息', '💰', ''],
      ['import-sku', '导入修改商品信息SKU', '📥', '']
    ]
  ],
  // [
  //   '服务与履约',
  //   [
  //     ['freight', '运费模板', '🚀'],
  //     ['limit-buy', '商品限购', '🚫'],
  //     ['service-lic', '服务资质', '📜'],
  //     ['7day', '7天无理由退换货', '↩'],
  //     ['big-goods', '大件商品', '📫'],
  //     ['warranty', '三包服务承诺', '🛡'],
  //     ['virtual', '虚拟商品', '💎'],
  //     ['install', '安装模式', '🔧']
  //   ]
  // ],
  // [
  //   '修改商品信息',
  //   [
  //     ['comprehensive', '综合修改(多字段修改)', '⚡'],
  //     ['price-stock', '价格-库存-SKU编码', '💰'],
  //     ['import-tpl', '导入修改(多模板)', '📥']
  //   ]
  // ]
]
const groups = groupData.map(([title, items]) => ({
  title,
  items: items.map(([id, label, icon, sub, badge]) => ({ id, label, icon, sub, badge }))
}))
const records = [
  {
    id: 1,
    type: '标题',
    rule: '批量补充热搜词「夏季新款」添加到标题前面',
    status: '已完成',
    progress: 100,
    success: 142,
    fail: 3,
    total: 145,
    time: '2026-07-13 10:30',
    restore: '2026-07-20 10:30'
  },
  {
    id: 2,
    type: '价格(SKU)',
    rule: 'SKU统一降价 ¥5，范围：全部在售商品',
    status: '处理中',
    progress: 63,
    success: 84,
    fail: 0,
    total: 134,
    time: '2026-07-13 14:22'
  },
  {
    id: 3,
    type: '主图',
    rule: 'AI重新生成主图，白底风格',
    status: '等待',
    progress: 0,
    success: 0,
    fail: 0,
    total: 58,
    time: '2026-07-13 15:01'
  },
  {
    id: 4,
    type: '库存',
    rule: '统一设置库存 999，范围：仓库中商品',
    status: '已完成',
    progress: 100,
    success: 36,
    fail: 1,
    total: 37,
    time: '2026-07-12 09:15'
  },
  {
    id: 5,
    type: 'SKU编码',
    rule: '批量更新SKU编码前缀「SH-2026」',
    status: '失败',
    progress: 12,
    success: 0,
    fail: 18,
    total: 18,
    time: '2026-07-11 16:40'
  }
]
export default {
  name: 'GoodsWorkbenchBatchModifyPage',
  components: {
    BatchModifyRecords,
    BatchModifyTitle,
    BatchModifyShortTitle,
    BatchModifyPrice,
    BatchModifyStock,
    BatchModifySizeWeight,
    BatchModifyDelete,
    BatchModifyDetail,
    BatchModifyMainImage,
    BatchModifyHuohao,
    BatchModifySkuSpec,
    BatchModifyImport
  },
  data() {
    return {
      groups,
      records,
      page: 'main',
      activeCard: null,
      tab: 'modify',
      titleTab: 'range',
      notice: false,
      preview: false,
      selector: false,
      detail: null,
      selected: [],
      recordType: '全部',
      failMode: 'truncate',
      recordTags: [
        '全部',
        '标题',
        '导购短标题',
        '品牌',
        '商品属性',
        '跨类目属性',
        '面料材质',
        '货号',
        '尺寸与重量',
        '删除商品',
        '下架/删除低效品',
        '上下架',
        '定时上下架',
        '创建渠道品',
        '限时限量购',
        '食品安全/营养成分表',
        '价格(SKU)',
        '库存',
        'SKU编码',
        'SKU规格名称/备注',
        '添加SKU',
        '删除SKU',
        '发货模式(SKU时效)',
        '预售时间',
        '商品详情图',
        '主图',
        '主图3:4',
        '库存计件',
        '尺码表',
        '区域库存开关',
        'SKU状态',
        'SKU规格图',
        'SKU图',
        '替换商品图片',
        '统一设置SKU',
        '白底图',
        '导入修改(多字段)',
        'SKU条形码（国补码）',
        '引用SKU模板',
        '多地址退货策略',
        '精选联盟策略',
        '主图视频',
        '运费模板',
        '商品限购',
        '服务资质',
        '7天无理由退换货',
        '大件商品',
        '三包服务承诺',
        '虚拟商品',
        '安装模式',
        '综合修改(多字段修改)',
        '价格-库存-SKU编码'
      ],
      filters: [
        '商品分类',
        '商品状态',
        '标题包含任一',
        '商品ID',
        '库存范围（件）',
        '售价范围（元）',
        '创建时间',
        '品牌',
        '搬家时间',
        '发货模式',
        '质量分',
        '运费模板',
        '是否分销',
        '货号精确匹配',
        '标记鉴图',
        '是否搬家商品',
        '销量（件）',
        '是否草稿',
        '是否曝光',
        '是否有流量',
        'SKU编码',
        'SKU名称',
        '面料材质',
        '洗水标吊牌图'
      ],
      methods: [
        '批量补充热搜词',
        '重新生成标题',
        '使用新内容',
        '删除关键字',
        '过滤内容',
        '英文转大小写',
        '商品关键字替换',
        '增加前缀/后缀',
        '删除首尾字数',
        '替换前缀内容'
      ].map((name, index) => ({ id: index + 1, name, on: index >= 3 && index <= 8 })),
      filterOptions: [
        '去除英文',
        '去除数字',
        '去除全部空格',
        '仅去除首尾空格',
        '去除英文符号',
        '去除货号',
        '去除括号及内容',
        '去除逗号'
      ],
      goods: Array.from({ length: 12 }, (_, index) => ({
        id: index + 1,
        title: `商品标题示例 ${String(index + 1).padStart(2, '0')}`,
        price: `¥${(29.9 + index * 10).toFixed(1)}`
      }))
    }
  },
  computed: {
    visibleRecords() {
      return this.recordType === '全部' ? this.records : this.records.filter((item) => item.type === this.recordType)
    }
  },
  methods: {
    openCard(item) {
      this.activeCard = item
      this.page =
        item.id === 'title'
          ? 'title-new'
          : item.id === 'short-title'
          ? 'short-title-new'
          : item.id === 'price'
          ? 'price-new'
          : item.id === 'stock'
          ? 'stock-new'
          : item.id === 'size-weight'
          ? 'size-weight-new'
          : item.id === 'del-goods'
          ? 'delete-new'
          : item.id === 'detail-img'
          ? 'detail-img-new'
          : item.id === 'main-img'
          ? 'main-img-new'
          : item.id === 'sku-no'
          ? 'huohao-new'
          : item.id === 'sku-spec'
          ? 'sku-spec-new'
          : item.id === 'import-spu'
          ? 'import-spu'
          : item.id === 'import-sku'
          ? 'import-sku'
          : 'placeholder'
    },
    toggleGood(id) {
      this.selected = this.selected.includes(id) ? this.selected.filter((item) => item !== id) : [...this.selected, id]
    }
  }
}
</script>

<style scoped>
.gx-bm {
  min-height: calc(100vh - 56px);
  margin: -24px 0px 0px -24px;
  background: #f5f6f8;
  color: #1a1a2e;
  font-family: 'Noto Sans SC', sans-serif;
}

.gx-bm button,
.gx-bm input,
.gx-bm select,
.gx-bm textarea {
  font: inherit;
}

.gx-bm button {
  cursor: pointer;
}

.gx-bm__tabs {
  display: flex;
  padding: 0 20px;
  border-bottom: 1px solid #e0e0ec;
  background: #fff;
}

.gx-bm__tabs button {
  padding: 9px 20px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 13px;
}

.gx-bm__tabs button.on {
  border-bottom-color: #c8443c;
  color: #c8443c;
  font-weight: 600;
}

.gx-bm__main,
.gx-bm__title-main {
  padding: 14px 20px 24px;
}

.gx-bm__heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.gx-bm h1 {
  margin: 0;
  font-family: 'Noto Serif SC', serif;
  font-size: 16px;
}

.gx-bm__heading span,
.gx-bm__title-head > a {
  color: #1677ff;
  font-size: 12px;
}

.gx-bm__group {
  margin-bottom: 20px;
}

.gx-bm__group > header,
.gx-bm__methods > header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 13px;
}

.gx-bm__group i,
.gx-bm__methods i {
  width: 3px;
  height: 14px;
  border-radius: 2px;
  background: #c8443c;
}

.gx-bm__group small {
  color: #999;
  font-size: 11px;
}

.gx-bm__grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
}

.gx-bm__card {
  position: relative;
  display: flex;
  min-height: 58px;
  flex-direction: column;
  gap: 4px;
  padding: 11px 10px 9px;
  overflow: hidden;
  border: 2px solid #e0e0ec;
  border-radius: 6px;
  background: #f5f0e8;
  color: #1a1a2e;
  text-align: left;
  transition: 0.15s;
}

.gx-bm__card:hover {
  border-color: #c8443c;
  background: #fff5f5;
}

.gx-bm__card > b {
  color: #c8443c;
  font: 16px 'JetBrains Mono', monospace;
}

.gx-bm__card strong {
  font-size: 11px;
  font-weight: 500;
}

.gx-bm__card small {
  color: #999;
  font-size: 9px;
}

.gx-bm__card em {
  position: absolute;
  right: 4px;
  top: 4px;
  padding: 1px 5px;
  border-radius: 3px;
  color: #fff;
  font-size: 9px;
  font-style: normal;
  font-weight: 600;
}

.gx-bm__card em.hot {
  background: #c8443c;
}

.gx-bm__card em.sale {
  background: #fa8c16;
}

.gx-bm__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
}

.gx-bm__tags button {
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 13px;
  background: #f5f5f5;
  color: #666;
  font-size: 11px;
}

.gx-bm__tags button.on {
  border-color: #1677ff;
  background: #1677ff;
  color: #fff;
}

.gx-bm__table-wrap,
.gx-bm__preview,
.gx-bm__detail {
  overflow: hidden;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.gx-bm__table-wrap {
  overflow-x: auto;
}

.gx-bm table {
  width: 100%;
  border-collapse: collapse;
}

.gx-bm__records table {
  min-width: 860px;
}

.gx-bm th {
  padding: 8px 12px;
  background: #f5f0e8;
  color: #666;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}

.gx-bm td {
  padding: 12px;
  border-bottom: 1px solid #f5f5f5;
  font-size: 12px;
}

.gx-bm td small {
  display: block;
  margin-top: 3px;
  color: #999;
  font-size: 10px;
  line-height: 1.7;
}

.gx-bm__progress {
  display: inline-block;
  width: 90px;
  height: 6px;
  overflow: hidden;
  border-radius: 3px;
  background: #f0f0f0;
}

.gx-bm__progress i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #c8443c, #e05858);
}

.gx-bm td > b {
  margin-left: 6px;
  color: #c8443c;
  font: 10px 'JetBrains Mono', monospace;
}

.gx-bm__status {
  padding: 2px 8px;
  border: 1px solid #ffd591;
  border-radius: 3px;
  background: #fff7e6;
  color: #fa8c16;
  font-size: 11px;
}

.gx-bm__status.已完成 {
  border-color: #b7eb8f;
  background: #f6ffed;
  color: #52c41a;
}

.gx-bm__status.失败 {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #c8443c;
}

.success {
  color: #52c41a;
  font-weight: 600;
}

.danger {
  color: #c8443c;
  font-weight: 600;
}

.gx-bm__mini {
  height: 23px;
  padding: 0 8px;
  border: 1px solid #e0e0ec;
  border-radius: 3px;
  background: #fff;
  color: #666;
  font-size: 10px;
}

.gx-bm__mini.primary {
  border-color: #91caff;
  background: #e6f4ff;
  color: #1677ff;
}

.gx-bm__table-wrap > footer {
  display: flex;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f5f0e8;
  color: #999;
  font-size: 11px;
}

.gx-bm__table-wrap input {
  width: 32px;
  border: 1px solid #e0e0ec;
}

.gx-bm__title-head {
  padding: 10px 20px 0;
  border-bottom: 1px solid #e0e0ec;
  background: #fff;
}

.gx-bm__title-head > div {
  display: flex;
  gap: 8px;
  align-items: center;
}

.gx-bm__title-head > div > button {
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 11px;
}

.gx-bm__title-head > div > span {
  color: #999;
  font-size: 12px;
}

.gx-bm__title-head > a {
  float: right;
  margin-top: -16px;
}

.gx-bm__title-head h1 {
  margin: 12px 0 8px;
  font-size: 18px;
}

.gx-bm__title-head .gx-bm__tabs {
  padding: 0;
}

.gx-bm__filters {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 12px;
  padding: 14px 16px 10px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.gx-bm__filters label {
  display: block;
  margin-bottom: 3px;
  color: #666;
  font-size: 10px;
}

.gx-bm__filters input,
.gx-bm__method-body input,
.gx-bm__method-body select,
.gx-bm__method-body textarea,
.gx-bm__options select {
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  font-size: 11px;
}

.gx-bm__filters footer {
  grid-column: 1/-1;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid #e0e0ec;
}

.gx-bm__filters footer button,
.gx-bm__choose button,
.gx-bm__bottom > button,
.gx-bm__selector footer button {
  height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #c8443c;
  color: #fff;
  font-size: 12px;
}

.gx-bm__filters footer .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

.gx-bm__choose,
.gx-bm__fail,
.gx-bm__options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 14px;
  padding: 10px 14px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #f5f0e8;
  color: #666;
  font-size: 12px;
}

.gx-bm__choose {
  background: #fff;
}

.gx-bm__choose button {
  background: #1677ff;
}

.gx-bm__choose span {
  color: #1677ff;
}

.gx-bm__fail {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #1a1a2e;
}

.gx-bm__methods {
  overflow: hidden;
  margin-bottom: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.gx-bm__methods > header {
  gap: 6px;
  margin: 0;
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  background: #f5f0e8;
  font-size: 12px;
  font-weight: 600;
}

.gx-bm__methods article {
  padding: 12px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.gx-bm__methods article:last-child {
  border-bottom: 0;
}

.gx-bm__method-body {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0 22px;
}

.gx-bm__method-body input {
  width: 200px;
}

.gx-bm__method-body textarea {
  width: 360px;
  height: 64px;
}

.gx-bm__method-body select {
  width: 130px;
}

.gx-bm__options select {
  width: 140px;
}

.gx-bm__preview header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 12px;
}

.gx-bm__preview header b {
  color: #1677ff;
}

.gx-bm__preview header button {
  float: right;
  border: 0;
  background: transparent;
  color: #c8443c;
}

.gx-bm__preview textarea {
  width: 100%;
  min-height: 38px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  font-size: 11px;
}

.gx-bm__bottom {
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-top: 1px solid #e0e0ec;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  font-size: 12px;
}

.gx-bm__bottom > button:first-child {
  background: #1677ff;
}

.gx-bm__bottom .green {
  margin-left: auto;
  padding: 0 28px;
  background: #52c41a;
}

.gx-bm__mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
}

.gx-bm__modal,
.gx-bm__selector,
.gx-bm__detail {
  width: min(400px, 100%);
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.gx-bm__selector,
.gx-bm__detail {
  width: min(720px, 100%);
}

.gx-bm__modal > header,
.gx-bm__selector > header,
.gx-bm__detail > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}

.gx-bm__modal > header button,
.gx-bm__selector > header button,
.gx-bm__detail > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
  line-height: 20px;
}

.gx-bm__modal > main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 28px 24px;
  text-align: center;
}

.gx-bm__modal > main > b {
  display: flex;
  width: 52px;
  height: 52px;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffd666;
  border-radius: 50%;
  background: #fffbe6;
  color: #c8443c;
  font-size: 28px;
}

.gx-bm__modal > main p {
  margin: 0;
  font-size: 13px;
}

.gx-bm__modal > footer,
.gx-bm__detail > footer {
  display: flex;
  justify-content: center;
  padding: 0 24px 20px;
}

.gx-bm__modal > footer button,
.gx-bm__detail > footer button {
  width: 120px;
  height: 32px;
  border: 0;
  border-radius: 6px;
  background: #1677ff;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.gx-bm__selector > main {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  max-height: 380px;
  padding: 14px 18px;
  overflow: auto;
}

.gx-bm__selector > main button {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border: 2px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  text-align: left;
}

.gx-bm__selector > main button.selected {
  border-color: #1677ff;
  background: #e6f4ff;
}

.gx-bm__selector > main b {
  height: 60px;
  background: #fff5f5;
  font-size: 28px;
  text-align: center;
}

.gx-bm__selector > main strong {
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gx-bm__selector > main small {
  color: #999;
  font: 10px 'JetBrains Mono', monospace;
}

.gx-bm__selector > footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  border-top: 1px solid #e0e0ec;
  font-size: 12px;
}

.gx-bm__selector > footer button {
  background: #1677ff;
}

.gx-bm__detail > nav {
  padding: 10px 18px;
  border-bottom: 1px solid #e0e0ec;
  color: #1677ff;
  font-size: 12px;
}

@media (max-width: 1180px) {
  .gx-bm__grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

@media (max-width: 820px) {
  .gx-bm__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .gx-bm__filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .gx-bm {
    margin: -16px;
  }

  .gx-bm__main,
  .gx-bm__title-main {
    padding: 14px 12px 20px;
  }

  .gx-bm__tabs {
    padding: 0 8px;
  }

  .gx-bm__tabs button {
    padding: 9px 12px;
  }

  .gx-bm__grid,
  .gx-bm__selector > main {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .gx-bm__filters {
    grid-template-columns: 1fr;
  }

  .gx-bm__bottom {
    padding: 10px 12px;
  }
}

.gx-bm__placeholder {
  display: flex;
  min-height: calc(100vh - 56px);
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 14px;
  color: #999;
}

.gx-bm__placeholder > b {
  font-size: 48px;
}

.gx-bm__placeholder > strong {
  color: #1a1a2e;
  font: 600 16px 'Noto Serif SC', serif;
}

.gx-bm__placeholder > span {
  font-size: 12px;
}

.gx-bm__placeholder > button {
  height: 32px;
  padding: 0 14px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 13px;
}
</style>

